import cities from './cities.json';
import exceptionalItems from './exceptionalItems.json';
export default {
  currentReceipt: {
    customerToken: "",
    receiptImageURL: "",
    createdAt: "",
    createdAtDate: "",
    createdAtTime: "",
    receiptDateTime: "",
    id: "",
    status: "",
    receiptId: "",
    orderId: "",
    vatNumber: "",
    sendSftp: "",
    total: "",
    reClaimed: 0,
    reClaimText: "",
    productTotal: 0,
    campaignTitle: "",
    rejectReason: "",
    declineReason: "",
    receiptNumber: "",
    campaign_fk: "",
    productImageURL: "",
    coinImageURL: "",
    retailerFk: "",
    paymentAmount: 0,
    hasWallet: false,
    isPending: false,
    campaignRetailers: [],
    location: "",
    products: [],
    processedProducts: [],
    selectedCheckbox: {
      vatMetro: { value: false, status: 0 },
      rossmannDiscount: { value: false, status: 0 }
    },
    hasEditableCoupons: false,
    couponsToCreate: 1,
    detailsText: "",
    campaignStartDate: "",
    campaignEndDate: "",
    referenceNumber: "",
    processHistory: [],
    paymentHistory: {},
    fraudResult: "",
    paymentStatus: "",
    selectedProducts: [],
    prevReceipts: [],
    usedReceipts: [],
    fraud: false,
    productImageLength: 0,
    country: "",
    used: false,
    dupRefNum: "",
    postCode: 0,
    retailerCity: '',
    ciuNumber: '',
    retailerName: '',
    retailerAddress: '',
    extra: {},
    clubCode: '',
    fiscalId: null,
    rppData: []
  },
  viewedProduct: [],
  fraudRiskScore: "",
  fraudModelScore: "",
  fraudModelWeights: {},
  currentCountry: "",
  vatMetro: {
    Germany: { value: 1.19, key: 19 },
    Austria: { value: 1.2, key: 20 }
  },
  reuploadLink: "",
  payoutLink: "",
  userToken: "",
  selectedRejectReason: "",
  isAdmin: "",
  userRoles: [],
  selectedReceptId: 0,
  dialogOpen: false,
  level: "",
  rejectReasons: [],
  declineReasons: [],
  reclaimReasons: [],
  locations: [],
  autoPilotMode: false,
  campaign: {},
  dashboarder: {},
  dashboardersList: [],
  campaignsList: [],
  dashboarderStats: {},
  snackBar: {
    message: "",
    timeout: 1500,
    type: "error" // success, info error, cyan, darken-2
  },
  showSnackBar: false,
  settings: {
    isDark: false
  },
  selectedDashboard: {},
  isTester: false,
  cities: cities,
  previewProgress: 0,
  exceptionalItems: exceptionalItems,
  reEvaluateReasons: [
    {
      id: 0,
      key: 'fullReceipt',
      message: 'RECEIPT IS FULL - ЧЕК ПОВНИЙ'
    },
    {
      id: 1,
      key: 'readableReceipt',
      message: 'RECEIPT IS READABLE - ВСІ НЕОБХІДНІ ДЕТАЛІ ДОБРЕ ЧИТАЮТЬСЯ НА ЧЕКУ'
    },
    {
      id: 2,
      key: 'minRequirementsMet',
      message: 'MINIMUM PRODUCT REQUIREMENTS ARE MET FOR THE THRESHOLD - НА ЧЕКУ ДОСТАТНЬО ТОВАРІВ ДЛЯ КАТЕГОРІЇ'
    },
    {
      id: 3,
      key: 'receiptImg',
      message: 'UPLOADED PHOTO SHOWS A RECEIPT - НА ФОТО САМЕ ЧЕК/КВИТАНЦІЯ'
    },
    {
      id: 4,
      key: 'validDate',
      message: 'RECEIPT DATE IS VALID - ДАТА ЧЕКА ВІРНА'
    },
    {
      id: 5,
      key: 'validRetailer',
      message: 'RETAILER IS VALID - МАГАЗИН БЕРЕ УЧАСТЬ У АКЦІЇ'
    },
    {
      id: 6,
      key: 'productClearlyVisible',
      message: 'PRODUCT IS CLEARLY VISIBLE ON THE RECEIPT- HERE IS THE DESCRIPTION - ТОВАР НА ЧЕКУ - ДОДАЮ ОПИС'
    },
    {
      id: 7,
      key: 'other',
      message: 'OTHER - HERE IS THE DESCRIPTION - ІНШЕ - ДОДАЮ ОПИС'
    }
  ],
  reEvaluateReasonsService: [
    {
      id: 0,
      key: 'fullReceipt',
      message: 'RECEIPT IS FULL'
    },
    {
      id: 1,
      key: 'readableReceipt',
      message: 'RECEIPT IS READABLE'
    },
    {
      id: 2,
      key: 'productClearlyVisible',
      message: 'PRODUCT IS CLEARLY VISIBLE ON THE RECEIPT'
    },
    {
      id: 3,
      key: 'validDate',
      message: 'RECEIPT DATE IS VALID - ДАТА ЧЕКА ВІРНА'
    },
    {
      id: 4,
      key: 'notFraud',
      message: 'RECEIPT IS NOT FRAUD/OVEREXPOSED'
    },
    {
      id: 5,
      key: 'validRetailer',
      message: 'RETAILER IS VALID'
    },
    {
      id: 6,
      key: 'other',
      message: 'OTHER - HERE IS THE DESCRIPTION'
    }
  ],
};
